import prodEXPService from "../../services/prodexpamend";
import lookerService from "../../services/looker";
const getDefaultState = () => {
    return {
        ProdEXPAmend: {
            ID: 0,
            VendorCode: null,
            VendorCodeOptions: null,
            RequestType: null,
            ChangeType: null,
            EmployeeAgency: null,
            AgencyName: null,
            VendorBusinessName: null,
            AccountingContactName: null,
            AccountingTitle: null,
            AccountingPhone: null,
            AccountingEmailAddress: null,
            InfoFromName: null,
            InfoFromTitle: null,
            InfoFromPhone: null,
            CurrentW9Attachment: null,
            IdentificationType: null,
            BankName: null,
            BankCountry: null,
            BankAddressLine1: null,
            BankAddressLine2: null,
            BankCity: null,
            BankState: null,
            BankZipCode: null,
            BankLetter: [],
            AccountName: null,
            AccountNumber: null,
            RoutingNumber: null,
            BankBIC: null,
            BankIBAN: null,
            RemittanceAdviceEmail: null,
            IsCreditCardAccepted: null,
            IsBankingInfoCollected: null,
            CreditCardFiles: [],
            IsDigitalMedia: null,
            IsMediaRepRequest: null,
            VendorInvoiceCopyFiles: [],
            USTaxID: null,
            Foreign: null,
            SocialSecurityNumber: null,
            IdentificationFiles: [],
            SampleMediaKitFiles: [],
            EmployeeTitle: null,
            EmployeePhoneNumber: null,
            AnyGiftOrCompensationOfferedToYouToPlaceOrder: null,
            CompensationReceived: null,
            EmployeeVendorRelationship: [],
            EmployeeVendorRelationshipDetails: {
                FormerEmployeeName: null,
                FamilyMemberName: null,
                FriendName: null,
                VendorRelationshipWithAgencyClient: null,
                VendorOfFormerEmployee: null,
                VendorWasFormerEmployeeOfAgency: null,
                VendorHasRelationshipWithAnotherAgencyEmployee: null,
                Other: null,
                ProdEXPAmendRequestID: 0,
                ID: 0,
            },
            Status: null,
            Attestation: false,
            RemittanceCountry: null,
            StreetAddressLine1: null,
            StreetAddressLine2: null,
            RemittanceCity: null,
            RemittanceState: null,
            RemittanceZipCode: null,
            InvoiceAttachment: [],
            Entity: null,
            EntityName: null,
            CompletedForms: [],
            IsPaidByWire: null,
            IsACHPayment: null,
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    ProdEXPAmend: (state) => {
        return state.ProdEXPAmend;
    },
};

// actions
const actions = {
    async GetFormData(st, id) {
        await prodEXPService
            .GetFormData(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((err) => {
                throw err;
            });
    },
    GetDraftFormData(st, id) {
        return prodEXPService.GetDraftFormData(id, st.rootState.auth.idToken);
    },
    GetRequestWithTaskDetails(st, id) {
        return prodEXPService.GetRequestWithTaskDetails(
            id,
            st.rootState.auth.idToken
        );
    },
    AddRequest(st, data) {
        return prodEXPService.AddRequest(data, st.rootState.auth.idToken);
    },
    AddRequestWithFiles(st, data) {
        return prodEXPService.AddRequestWithFiles(data, st.rootState.auth.idToken);
    },
    ApproveRequestLevel1(st, data) {
        return prodEXPService.ApproveRequestLevel1(data, st.rootState.auth.idToken);
    },
    ApproveRequestLevel2(st, data) {
        return prodEXPService.ApproveRequestLevel2(data, st.rootState.auth.idToken);
    },
    ApproveRequestLevel3(st, data) {
        return prodEXPService.ApproveRequestLevel3(data, st.rootState.auth.idToken);
    },
    AccountingApprove(st, data) {
        return prodEXPService.AccountingApprove(data, st.rootState.auth.idToken);
    },
    CFOApprove(st, data) {
        return prodEXPService.CFOApprove(data, st.rootState.auth.idToken);
    },
    CompleteRequest(st, data) {
        return prodEXPService.CompleteRequest(data, st.rootState.auth.idToken);
    },
    RejectRequestLevel1(st, data) {
        return prodEXPService.RejectRequestLevel1(data, st.rootState.auth.idToken);
    },
    RejectRequestLevel2(st, data) {
        return prodEXPService.RejectRequestLevel2(data, st.rootState.auth.idToken);
    },
    RejectRequestLevel3(st, data) {
        return prodEXPService.RejectRequestLevel3(data, st.rootState.auth.idToken);
    },
    RejectVendorValidation(st, data) {
        return prodEXPService.RejectVendorValidation(data, st.rootState.auth.idToken);
    },
    AccountingReject(st, data) {
        return prodEXPService.AccountingReject(data, st.rootState.auth.idToken);
    },
    CFOReject(st, data) {
        return prodEXPService.CFOReject(data, st.rootState.auth.idToken);
    },
    GetRequests(st, options) {
        return prodEXPService.GetRequests(st.rootState.auth.idToken, options);
    },
    RenderUploadedFiles(st, { id, category }) {
        return prodEXPService.RenderUploadedFiles(
            st.rootState.auth.idToken,
            id,
            category
        );
    },
    UpdateRequestWithFiles(st, { id, data }) {
        return prodEXPService.UpdateRequestWithFiles(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetUsers(st, { agencyName, name }) {
        return prodEXPService.GetUsers(st.rootState.auth.idToken, agencyName, name);
    },
    SaveAsDraft(st, data) {
        return prodEXPService.SaveAsDraft(data, st.rootState.auth.idToken);
    },

    GetAuditFormData(st, id) {
        return prodEXPService.GetAuditFormData(id, st.rootState.auth.idToken);
    },
    GetWorkflowStates(st, id) {
        return prodEXPService.GetWorkflowStates(id, st.rootState.auth.idToken);
    },
    ReassignDirectorApproval(st, data) {
        return prodEXPService.ReassignDirectorApproval(data, st.rootState.auth.idToken);
    },
    GetWorkflowHistoryStates(st, id) {
        return prodEXPService.GetWorkflowHistoryStates(
            id,
            st.rootState.auth.idToken
        );
    },
    PendingVendorApproveorComplete(st, data) {
        return prodEXPService.PendingVendorApproveorComplete(
            data,
            st.rootState.auth.idToken
        );
    },
    GetD365VendorData(st, data) {
        return lookerService.GetD365VendorData(st.rootState.auth.idToken, data);
    },
    GetRequestorById(st, id) {
        return prodEXPService.GetRequestorById(
            id,
            st.rootState.auth.idToken
        );
    },
    SaveRequestAsDraft(st, draftRequestId) {
        var DraftObj = {};
        DraftObj.DraftRequestID =
            draftRequestId != null && !isNaN(draftRequestId) ?
            parseInt(draftRequestId) :
            null;
        DraftObj.EmployeePhoneNumber = st.getters.ProdEXPAmend.EmployeePhoneNumber;
        DraftObj.Entity = st.getters.ProdEXPAmend.Entity;
        DraftObj.EmployeeAgency = st.getters.ProdEXPAmend.EmployeeAgency;
        DraftObj.AgencyName = st.getters.ProdEXPAmend.AgencyName;
        DraftObj.RequestType = st.getters.ProdEXPAmend.RequestType;
        DraftObj.ChangeType = st.getters.ProdEXPAmend.ChangeType;
        DraftObj.Files = [];
        let CompletedForms = st.getters.ProdEXPAmend.CompletedForms;
        if (CompletedForms != null && CompletedForms.length > 0) {
            CompletedForms.forEach(completedForms => {
                DraftObj.Files.push({ Category: `CompletedForms`, Name: completedForms.Name || completedForms.name })
            });
        }
        DraftObj.VendorCodeOptions = st.getters.ProdEXPAmend.VendorCodeOptions
        DraftObj.VendorBusinessName = st.getters.ProdEXPAmend.VendorBusinessName;
        let InvoiceAttachment = st.getters.ProdEXPAmend.InvoiceAttachment;
        let IdentificationFiles = st.getters.ProdEXPAmend.IdentificationFiles;
        if (IdentificationFiles != null && IdentificationFiles.length > 0) {
            IdentificationFiles.forEach(identificationFiles => {
                DraftObj.Files.push({ Category: `IdentificationFiles`, Name: identificationFiles.Name || identificationFiles.name })
            });
        }
        if (InvoiceAttachment != null && InvoiceAttachment.length > 0) {
            InvoiceAttachment.forEach(invoiceAttachment => {
                DraftObj.Files.push({ Category: `InvoiceAttachment`, Name: invoiceAttachment.Name || invoiceAttachment.name })
            });
        }
        DraftObj.RemittanceCountry = st.getters.ProdEXPAmend.RemittanceCountry;
        DraftObj.StreetAddressLine1 = st.getters.ProdEXPAmend.StreetAddressLine1;
        DraftObj.StreetAddressLine2 = st.getters.ProdEXPAmend.StreetAddressLine2;
        DraftObj.RemittanceCity = st.getters.ProdEXPAmend.RemittanceCity;
        DraftObj.RemittanceState = st.getters.ProdEXPAmend.RemittanceState;
        DraftObj.RemittanceZipCode = st.getters.ProdEXPAmend.RemittanceZipCode;
        DraftObj.AccountingContactName = st.getters.ProdEXPAmend.AccountingContactName;
        DraftObj.AccountingTitle = st.getters.ProdEXPAmend.AccountingTitle;
        DraftObj.AccountingPhone = st.getters.ProdEXPAmend.AccountingPhone;
        DraftObj.AccountingEmailAddress = st.getters.ProdEXPAmend.AccountingEmailAddress;
        DraftObj.InfoFromName = st.getters.ProdEXPAmend.InfoFromName;
        DraftObj.InfoFromTitle = st.getters.ProdEXPAmend.InfoFromTitle;
        DraftObj.InfoFromPhone = st.getters.ProdEXPAmend.InfoFromPhone;
        DraftObj.CurrentW9Attachment = st.getters.ProdEXPAmend.CurrentW9Attachment;
        DraftObj.IdentificationType = st.getters.ProdEXPAmend.IdentificationType;
        DraftObj.USTaxID = st.getters.ProdEXPAmend.USTaxID;
        DraftObj.Foreign = st.getters.ProdEXPAmend.Foreign;
        DraftObj.SocialSecurityNumber = st.getters.ProdEXPAmend.SocialSecurityNumber;
        DraftObj.BankName = st.getters.ProdEXPAmend.BankName;
        DraftObj.BankCountry = st.getters.ProdEXPAmend.BankCountry;
        DraftObj.BankAddressLine1 = st.getters.ProdEXPAmend.BankAddressLine1;
        DraftObj.BankAddressLine2 = st.getters.ProdEXPAmend.BankAddressLine2;
        DraftObj.BankCity = st.getters.ProdEXPAmend.BankCity;
        DraftObj.BankState = st.getters.ProdEXPAmend.BankState;
        DraftObj.BankZipCode = st.getters.ProdEXPAmend.BankZipCode;
        DraftObj.AccountName = st.getters.ProdEXPAmend.AccountName;
        DraftObj.AccountNumber = st.getters.ProdEXPAmend.AccountNumber;
        DraftObj.RoutingNumber = st.getters.ProdEXPAmend.RoutingNumber;
        DraftObj.BankBIC = st.getters.ProdEXPAmend.BankBIC;
        DraftObj.BankIBAN = st.getters.ProdEXPAmend.BankIBAN;
        DraftObj.RemittanceAdviceEmail = st.getters.ProdEXPAmend.RemittanceAdviceEmail;
        let BankLetter = st.getters.ProdEXPAmend.BankLetter;
        if (BankLetter != null && BankLetter.length > 0) {
            BankLetter.forEach(bankLetter => {
                DraftObj.Files.push({ Category: `BankLetter`, Name: bankLetter.Name || bankLetter.name })
            });
        }
        DraftObj.EmployeeVendorRelationship =
            (st.getters.ProdEXPAmend.EmployeeVendorRelationship || []).map(name => ({
                ID: 0,
                RelationshipName: name
            }));
        DraftObj.EmployeeVendorRelationshipDetails = st.getters.ProdEXPAmend.EmployeeVendorRelationshipDetails;
        DraftObj.EmployeeVendorRelationshipDetails.ID = 0;
        DraftObj.CompensationReceived = st.getters.ProdEXPAmend.CompensationReceived;
        const draftFieldsToConvert = [
            "IsPaidByWire",
            "IsACHPayment",
            "AnyGiftOrCompensationOfferedToYouToPlaceOrder",
            "CurrentW9Attachment"
        ];
        draftFieldsToConvert.forEach(field => {
            DraftObj[field] = st.getters.ProdEXPAmend[field];
            if (st.getters.ProdEXPAmend[field] === "Yes" || st.getters.ProdEXPAmend[field] === "YES" || st.getters.ProdEXPAmend[field] === "true") {
                DraftObj[field] = true;
            } else if (st.getters.ProdEXPAmend[field] === "No" || st.getters.ProdEXPAmend[field] === "NO" || st.getters.ProdEXPAmend[field] === "false") {
                DraftObj[field] = false;
            } else {
                DraftObj[field] = null;
            }
        });
        let formData = new FormData();
        formData.append("request", JSON.stringify(DraftObj));

        for (let i = 0; i < CompletedForms.length; i++) {
            let file = CompletedForms[i];
            formData.append(`CompletedForms`, file.file);
        }
        for (let i = 0; i < BankLetter.length; i++) {
            let file = BankLetter[i];
            formData.append(`BankLetter`, file.file);
        }
        for (let i = 0; i < InvoiceAttachment.length; i++) {
            let file = InvoiceAttachment[i];
            formData.append(`InvoiceAttachment`, file.file);
        }
        for (let i = 0; i < IdentificationFiles.length; i++) {
            let file = IdentificationFiles[i];
            formData.append(`IdentificationFiles`, file.file);
        }
        return prodEXPService.SaveRequestAsDraft(st.rootState.auth.idToken, formData);
    },
    GetDraftRequest(st, id) {
        prodEXPService
            .GetDraftRequest(id, st.rootState.auth.idToken)
            .then((res) => {
                st.commit("loadVendorData", res.data);
                st.commit("loadVendorFiles", res.data);
                return res.data;
            })
            .catch((error) => {
                return error;
            });
    },
    DeleteDraft(st, id) {
        return prodEXPService.DeleteDraft(st.rootState.auth.idToken, id);
    },
};

function GetFilesCategory() {
    return ["IdentificationFiles", "BankLetter", "InvoiceAttachment", "CompletedForms"];
}
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
    loadVendorData(state, data) {
        Object.assign(state.ProdEXPAmend, data);
        state.ProdEXPAmend.CurrentW9Attachment =
            data.CurrentW9Attachment === true ? "Yes" :
            data.CurrentW9Attachment === false ? "No" : null;
        state.ProdEXPAmend.BankState = data.SelectedStateName;
        state.ProdEXPAmend.VendorCode = `${data.VendorCodeOptions} - ${data.VendorBusinessName}`;
        if (state.ProdEXPAmend.EmployeeVendorRelationship != null) {
            state.ProdEXPAmend.EmployeeVendorRelationship = state.ProdEXPAmend.EmployeeVendorRelationship.map(
                (name) => name.RelationshipName
            );
        }
        state.ProdEXPAmend.AnyGiftOrCompensationOfferedToYouToPlaceOrder =
            data.AnyGiftOrCompensationOfferedToYouToPlaceOrder === true ? "true" :
            data.AnyGiftOrCompensationOfferedToYouToPlaceOrder === false ? "false" : null;
        state.ProdEXPAmend.IsPaidByWire =
            data.IsPaidByWire === true ? "YES" :
            data.IsPaidByWire === false ? "NO" : null;

        state.ProdEXPAmend.IsACHPayment =
            data.IsACHPayment === true ? "YES" :
            data.IsACHPayment === false ? "NO" : null;
        state.ProdEXPAmend.IdentificationFiles = [];
        state.ProdEXPAmend.BankLetter = [];
        state.ProdEXPAmend.InvoiceAttachment = [];
        state.ProdEXPAmend.CompletedForms = [];
    },
    loadVendorFiles(state, data) {
        if (data.Files.length > 0) {
            GetFilesCategory().forEach((file) => {
                if (typeof file == "undefined" || file == null) {
                    return;
                } else {
                    let files = data.Files.filter((catFile) => {
                        return catFile.Category == file;
                    });
                    if (files.length > 0) {
                        files.forEach((originalFile) => {
                            state.ProdEXPAmend[file].push(originalFile);
                        });
                    }
                }
            });
        }
        state.ProdEXPAmend.IsEditDataLoaded = true;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};